// s32-pubkey_not_found.js
import selfHtml from './s32-pubkey_not_found.html' with { type: 'text' };;


var root

export async function init(module_root, args) {

    module_root.innerHTML = selfHtml;

    root = module_root

}